import { styled } from '@mui/material';
import palette from 'theme/palette';
import { Typography } from 'ui';

export const TypographyLink = styled(Typography, {
  shouldForwardProp: prop => prop !== 'hasLink'
})<{ hasLink: boolean }>(({ hasLink, theme }) => ({
  color: palette.primary.link,
  textDecoration: 'none',
  ...(hasLink
    ? {
        '&:hover': {
          cursor: 'pointer',
          color: palette.secondary.link
        }
      }
    : {})
}));
